import { useContext } from "react";
import { ApiErrorContext } from "./api-error-context";

export const useApiErrorContext = () => useContext(ApiErrorContext);
